/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './qr-code-panel.component';
import * as import2 from '../../../../../node_modules/angular2-qrcode/lib/angular2-qrcode.ngfactory';
import * as import3 from 'angular2-qrcode';
import * as import4 from '../../../orchestration/navigation.service';
const styles_QrCodePanelComponent:any[] = ([] as any[]);
export const RenderType_QrCodePanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_QrCodePanelComponent,
  data: {}
}
);
export function View_QrCodePanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'qr-code',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import1.QrCodePanelComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.expand($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import2.View_QRCodeComponent_0,import2.RenderType_QRCodeComponent)),
    import0.ɵdid(573440,(null as any),0,import3.QRCodeComponent,[import0.ElementRef],{
      background: [
        0,
        'background'
      ]
      ,
      foreground: [
        1,
        'foreground'
      ]
      ,
      level: [
        2,
        'level'
      ]
      ,
      size: [
        3,
        'size'
      ]
      ,
      value: [
        4,
        'value'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import1.QrCodePanelComponent = v.component;
    const currVal_0:any = '#DDD';
    const currVal_1:any = '#444';
    const currVal_2:any = 'M';
    const currVal_3:any = 90;
    const currVal_4:any = co.value;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_QrCodePanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-qr-code-panel',([] as any[]),(null as any),(null as any),(null as any),View_QrCodePanelComponent_0,RenderType_QrCodePanelComponent)),
    import0.ɵdid(49152,(null as any),0,import1.QrCodePanelComponent,[import4.NavigationService],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const QrCodePanelComponentNgFactory:import0.ComponentFactory<import1.QrCodePanelComponent> = import0.ɵccf('woa-qr-code-panel',import1.QrCodePanelComponent,View_QrCodePanelComponent_Host_0,{
  value: 'value',
  displayValue: 'displayValue',
  message: 'message'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvcXItY29kZS9xci1jb2RlLXBhbmVsL3FyLWNvZGUtcGFuZWwuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvcXItY29kZS9xci1jb2RlLXBhbmVsL3FyLWNvZGUtcGFuZWwuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC91aS1lbGVtZW50cy9xci1jb2RlL3FyLWNvZGUtcGFuZWwvcXItY29kZS1wYW5lbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvcXItY29kZS9xci1jb2RlLXBhbmVsL3FyLWNvZGUtcGFuZWwuY29tcG9uZW50LnRzLlFyQ29kZVBhbmVsQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHFyLWNvZGUgW2JhY2tncm91bmRdPVwiJyNEREQnXCIgW2ZvcmVncm91bmRdPVwiJyM0NDQnXCIgW2xldmVsXT1cIidNJ1wiIFtzaXplXT1cIjkwXCIgW3ZhbHVlXT1cInZhbHVlXCJcbiAgICAgICAgIChjbGljayk9XCJleHBhbmQoJGV2ZW50KVwiPjwvcXItY29kZT5cbiIsIjx3b2EtcXItY29kZS1wYW5lbD48L3dvYS1xci1jb2RlLXBhbmVsPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUNTO1FBQUE7UUFBQTtNQUFBO01BRFQ7SUFBQTtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFDNEM7Ozs7SUFEbkM7SUFBc0I7SUFBc0I7SUFBYztJQUFZO0lBQS9FLFNBQVMsVUFBc0IsVUFBc0IsVUFBYyxVQUFZLFNBQS9FOzs7OztJQ0FBO2dCQUFBOzs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/app/ui-elements/qr-code/qr-code-panel/qr-code-panel.component.ngfactory.ts